'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _objectSpread = _interopDefault(require('@babel/runtime/helpers/objectSpread'));
var utils = require('../utils');

var index = utils.createSimpleFC({
  tag: 'button',
  name: 'button',
  className: function className(_ref) {
    var props = _ref.props;
    return ['btn', {
      outline: utils.hasProp(props.outline),
      disabled: utils.hasProp(props.disabled),
      gradient: utils.hasProp(props.gradient) && !utils.hasProp(props.outline),
      round: utils.hasProp(props.round),
      load: typeof props.loading === 'boolean'
    }];
  },
  updateData: function updateData(ctx) {
    var loading = '';
    var text = ctx.props.text || '';

    if (ctx.props.loading) {
      loading = '<div class="icon-no-shake"><i class="icon-spin"></i></div>';

      if (!ctx.props.showLoadingText) {
        text = '';
      }
    }

    var innerHTML = loading + text;

    if (innerHTML) {
      ctx.data.domProps = _objectSpread({}, ctx.data.domProps, {
        innerHTML: innerHTML
      });
    }

    return ctx;
  }
});

exports.default = index;
